# All the possible tabs on the left, which open the settings panel.
# The page route corresponds to the key of the selected tab.
# The route "/" means that the settings panel is closed.

state =
    open:
        icon: ['fas', 'chevron-right']
        text: 'Open'
    close:
        icon: ['fas', 'chevron-left']
        text: 'Close'
    details:
        icon: ['fas', 'circle-info']
        text: 'Details'
        title: 'View or review a movie or episode'
    show:
        icon: ['far', 'eye']
        text: 'Show'
        title: 'Choose what to show in the lists'
    search:
        icon: ['fas', 'search']
        text: 'Search'
        title: 'Filter by text matches'
    filter:
        icon: ['fas', 'filter']
        text: 'Filter'
        title: 'Remove or require certain properties'
    sort:
        icon: ['fas', 'sort']
        text: 'Sort'
        title: 'Choose how to sort the lists'
    data:
        icon: ['fas', 'database']
        text: 'Data'
        title: 'View what is currently loaded or load more movies or episodes'
    about:
        icon: ['fas', 'question']
        text: 'About'
        title: 'Created by koenbot © 2019'

export default {
    namespaced: true
    state
}